import * as React from 'react'
import {
  List,
  TextField,
  NumberField,
  DateField,
  EmailField,
  SelectField,
  TextInput,
  FunctionField,
  TopToolbar,
  FilterButton,
  ExportButton,
} from 'react-admin'
import CustomizableDatagrid from 'ra-customizable-datagrid'
import { useTranslate } from 'ra-core'
import { MyPagination } from '../../MyPagination'
import StatusChip from '../../components/StatusChip'

const userFilters = [
  <TextInput key="email" source="email" />,
  <TextInput key="phone" source="phone" />,
]

const UserListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
)

const UserList = props => {
  const translate = useTranslate()
  return (
    <List
      {...props}
      actions={<UserListActions />}
      bulkActionButtons={false}
      sort={{ field: 'id', order: 'DESC' }}
      filters={userFilters}
      pagination={<MyPagination />}
    >
      <CustomizableDatagrid
        defaultColumns={['id', 'status', 'email', 'name', 'surnames', 'phone']}
      >
        <NumberField source="id" sortByOrder="DESC" />
        <FunctionField
          label={translate('surveys.common.status')}
          render={record => (
            <StatusChip
              value={record.status}
              activeLabel={translate('surveys.common.active')}
              inactiveLabel={translate('surveys.common.desactive')}
            />
          )}
        />
        <EmailField source="email" />
        <TextField source="name" />
        <TextField source="surnames" />
        <NumberField source="phone" />
        <NumberField source="postalCode" />
        <SelectField
          source="gender"
          choices={[
            { id: 'M', name: 'Male' },
            { id: 'F', name: 'Female' },
          ]}
        />
        <DateField source="dob.date" label="Birthdate" />
        <TextField source="data.ip" label="Ip" />
        <TextField
          source="data.origen"
          label={translate('surveys.common.origin')}
        />
        <TextField
          source="country"
          label={translate('surveys.common.country')}
        />
      </CustomizableDatagrid>
    </List>
  )
}

export default UserList
